import React from "react";
import { Link } from "react-router-dom";
import { CALCULATORS } from "../calculators";
import usePageMeta from "../usePageMeta";
import AdSlot from "../components/AdSlot";

function Home() {
  usePageMeta(
    "Hisaab Tools – Free Online Calculators for Everyday Use",
    "Free online calculators: age, BMI, loan EMI, compound interest, percentage, discount, tip, currency, unit conversion, and days between dates. No signup, no downloads."
  );

  return (
    <main className="page page-wide">
      <section className="hero fade-in">
        <h1>Free Online Calculators for Everyday Life</h1>
        <p>
          Quick, accurate, and completely free. Pick a calculator below — no
          signup, no downloads, and everything runs right in your browser.
        </p>
      </section>

      <section className="calc-grid">
        {CALCULATORS.map((calc) => (
          <Link key={calc.path} to={calc.path} className="calc-tile fade-in">
            <span className="calc-tile-icon">{calc.icon}</span>
            <h2>{calc.name}</h2>
            <p>{calc.description}</p>
          </Link>
        ))}
      </section>

      <AdSlot />

      <section className="seo-content">
        <h2>Why use Hisaab Tools?</h2>
        <p>
          Everyday math shouldn't require a spreadsheet. Whether you're
          figuring out a restaurant tip, checking how a loan payment fits your
          budget, converting units for a recipe, or seeing how your savings
          grow over time, these tools give you an instant answer with a clear
          explanation of how it was calculated.
        </p>
        <p>
          Every calculator on this site runs entirely in your browser. Nothing
          you type is sent to a server or stored anywhere — your numbers stay
          on your device. The tools work on phones, tablets, and desktops, and
          they're always free to use.
        </p>

        <h2>Frequently asked questions</h2>
        <h3>Are these calculators free to use?</h3>
        <p>
          Yes. Every tool on Hisaab Tools is completely free, with no sign-up,
          no account, and no download required. The site is supported by
          advertising.
        </p>
        <h3>Is my data private?</h3>
        <p>
          All calculations happen locally in your browser. The numbers and
          dates you enter are never uploaded to a server or stored, and they're
          discarded as soon as you close the page.
        </p>
        <h3>Do the calculators work on mobile?</h3>
        <p>
          Yes. The site is designed to work on phones, tablets, and desktop
          browsers, so you can run any calculation wherever you are.
        </p>
        <h3>Which Pakistan-specific tools are available?</h3>
        <p>
          Alongside the everyday calculators, Hisaab Tools includes a{" "}
          <Link to="/zakat">Zakat calculator</Link> and a{" "}
          <Link to="/pakistan-income-tax">Pakistan income tax calculator</Link>{" "}
          based on the latest FBR salary tax slabs.
        </p>
      </section>
    </main>
  );
}

export default Home;
